<script setup lang="ts">
const emit = defineEmits<{
  (e: "scrollToContent"): void;
}>();
</script>

<template>
  <div>
    <h1 class="mb-10 hidden text-4xl font-bold uppercase md:block">
      Your home for poker entertainment!
    </h1>

    <div>
      <div class="mx-auto flex max-w-6xl justify-center gap-20">
        <div class="relative w-1/2 border border-white p-10">
          <div class="relative z-10 flex flex-col items-center gap-6">
            <div class="text-2xl">
              100+ DAYS OF LIVE POKER<br />
              24/7 ON DEMAND ACCESS
            </div>
            <Button
              fluid
              class="submit-payment"
              @click="emit('scrollToContent')"
            >
              <font-awesome-icon :icon="['fas', 'play']" class="mr-2" />
              Watch Poker
            </Button>
            <div>
              Available on iPhone, iPad, Android phone, Android tablet, Apple
              TV, Roku, Amazon TV, and browser
            </div>
          </div>

          <div
            class="absolute inset-0 bg-[url(~/assets/images/marketing/watch-background.jpg)] !bg-cover blur-[1px]"
          />
          <div
            class="absolute inset-0"
            style="background: rgba(0, 0, 0, 0.4)"
          />
        </div>

        <div class="relative w-1/2 border border-white p-10">
          <div class="relative z-10 flex flex-col items-center gap-6">
            <div class="text-2xl">
              FREE ONLINE POKER<br />
              ANYTIME, ANYWHERE
            </div>
            <NuxtLink
              to="https://playpokergo.onelink.me/YuJc/nh56lr4w"
              target="_blank"
              class="block w-full"
            >
              <Button
                fluid
                class="submit-payment"
                @click="emit('scrollToContent')"
              >
                <font-awesome-icon :icon="['fas', 'cards']" class="mr-2" /> Play
                Poker
              </Button>
            </NuxtLink>
            <div>
              Available on iPhone, iPad, Android phone, Android tablet, and
              browser
            </div>
          </div>

          <div
            class="absolute inset-0 bg-[url(~/assets/images/marketing/play-background.jpg)] !bg-cover blur-[1px]"
          />
          <div
            class="absolute inset-0"
            style="background: rgba(0, 0, 0, 0.4)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
